import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './About.css';
import aboutImage from '../../assets/images/about.jpg';

const About = () => {
  return (
    <section className="about">
      <div className="about-container">
        
        <motion.div 
          className="about-image-wrapper"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
        >
          <img src={aboutImage} alt="Yoga Instructor" className="about-img" />
          <div className="experience-badge">
            <span className="years">15+</span>
            <span className="text">Years of<br/>Experience</span>
          </div>
        </motion.div>
        
        <motion.div 
          className="about-content"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h4 className="section-subtitle">Our Story</h4>
          <h2 className="section-title">A Sanctuary for Wellness & Healing.</h2>
          <p className="about-text">
            For over a decade, we have been dedicated to providing a safe, welcoming, and inspiring environment for yogis of all levels. We believe that yoga is not just a physical practice, but a journey of self-discovery, spiritual growth, and mindful living.
          </p>
          <p className="about-text">
            Our expert instructors bring decades of combined experience, offering personalized guidance to help you achieve balance, strength, and inner peace in every aspect of your life.
          </p>
          
          <ul className="about-features">
            <li><span className="check">✓</span> Expert Certified Instructors</li>
            <li><span className="check">✓</span> Holistic Approach to Wellness</li>
            <li><span className="check">✓</span> Modern & Serene Studio Environment</li>
          </ul>

          <Link to="/about" className="btn-outline">Discover More</Link>
        </motion.div>

      </div>
    </section>
  );
};

export default About;
